import React, { useState, useEffect } from "react";
// import { useUserDetailContext } from '../../../UserDetailContext';
import useApi from "../../../Utilities/useAPI";
import axios from "axios";
import { useMediaQuery } from "@mui/material";
import { QrCodeVisitingCard } from "../../Cards/QrCodeCard";
import { Link, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import DefaultUniversity from "../../../../Assets/img/default-university-logo.jpg";
import {
  formatTimeAmPm,
  sortListByDate,
} from "../../../Utilities/ValidationFunctions";
import PreviewFileItem, {
  PreviewImage,
  PreviewUrlThumbnail,
  PreviewVideo,
} from "../../../Utilities/PreviewFileItem";
import { transformProjectData } from "../ParentProfile";
import { getIconAndLabel } from "../../../Utilities/SocialMediaMapping";
import { motion } from "framer-motion";

// Component-specific Design Imports
import Temp_logo from "../../../../Assets/img/Profile/Logo.svg";
import Nav_line from "../../../../Assets/img/Profile/Nav-bar-design-line.png";
import School_logo from "../../../../Assets/img/Profile/School-logo.svg";
import logo_right from "../../../../Assets/img/Profile/Neoin-E.png";
import Default_profile from "../../../../Assets/img/profile-pic2.jpg";
import line_bottom from "../../../../Assets/img/Profile/line_bottom_portfolio.png";
import qr_code from "../../../../Assets/img/QR.svg";
import dot_styles from "../../../../Assets/img/Profile/dot-styles.png";
import list_experience from "../../../../Assets/img/Profile/list_point_Experience.png";
import projectImage1 from "../../../../Assets/img/Profile/Project_image.png";
import phone_icon from "../../../../Assets/img/icons/phone-portfolio.svg";
import email_icon from "../../../../Assets/img/icons/Email-portfolio.svg";
import location_icon from "../../../../Assets/img/icons/Location-portfolio.svg";
import instagram_icon from "../../../../Assets/img/icons/Instagram-portfolio.svg";
import full_line from "../../../../Assets/img/icons/full line.png";
import half_line_left from "../../../../Assets/img/icons/half-left-line.png";
import half_line_right from "../../../../Assets/img/icons/half-right-line.png";
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { ReactComponent as DownloadIcon } from "../../../../Assets/img/icons/Download-share.svg"
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useProfileContext } from "../../../../Components/ProfileDetailContext";

const Portfolio = () => {
  const [activeMenu, setActiveMenu] = useState("cover");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const encryptedId = searchParams.get("encryptedId");
  const encryptedUserId = decodeURIComponent(encryptedId);
  const { openDocumentViewer } = useProfileContext();
  const bytes = CryptoJS.AES.decrypt(
    decodeURIComponent(encryptedUserId),
    "UserDetailsSecretKey"
  );
  const refId = bytes.toString(CryptoJS.enc.Utf8);
  const link = searchParams.get("link")?.trim();
  // const { callApiFunction } = useApi();
  // const { userDetails } = useUserDetailContext();
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${link}`,
  };

  const getUserInfo = async () => {
    const endpoint = "getUserDetails";
    const payload = { userId: refId };
    try {
      //   const response = await callApiFunction(endpoint, payload);

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/user-details`,
        payload, // Pass the payload directly
        {
          headers: headers, // Correctly passing headers
        }
      );
      //    console.log("user info liog 1", response.data);
      if (response?.data?.status == "SUCCESS") {
        const data = response?.data?.data;
        setUserDetails((prevDetails) => ({
          ...prevDetails,
          name: data?.first_name + " " + data?.last_name,
          proFile: data?.profile_url,
          email: data?.email,
          phone: data?.phone_no,
          token: data?.token,
        }));

        setProfessionalCardDetails((prevData) => ({
          ...prevData,
          cardName: "Professional",
          token: data?.token,
          encryptedId: encryptedId,
        }));
      }
    } catch (error) {
      console.log("GET for homeInfo failed:", error);
    }
  };

  const getProfessionalCardInfo = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/card/getacardadditionalinfo`,
        {
          cardTypes: ["Professional"],
          viewedUserId: refId,
        },
        {
          headers: headers,
        }
      );

      const professionalDetails = response?.data?.Professional[0] || {};

      console.log("professionalDetails", professionalDetails)

      if (Object.keys(professionalDetails).length > 0) {
        setProfessionalCardDetails((prevData) => ({
          ...prevData,
          cardName: "Professional",
          designation: professionalDetails?.designation || "",
          company: professionalDetails?.company || "",
          profile_pic: professionalDetails?.profile_pic || "",
          logo: professionalDetails?.logo || "",
          userRefId: refId,
          encryptedId: encryptedId,
        }));
      } else {
        setProfessionalCardDetails({});
      }
    } catch (error) {
      console.log("Could not fetch Professional Card Info:", error);
    }
  };

  const getHomeInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_profile`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      if (response?.data?.status === "SUCCESS") {
        const data = response?.data?.data;
        setHomeInfo((prevDetails) => ({
          ...prevDetails,
          profilePicture: data?.user_profile_url,
          aboutMe: data?.about_me,
          isAboutMePublic: data?.is_about_public,
        }));
      }

      const responseSkills = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_skils`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );

      // console.log("RESPONSE", responseSkills);
      if (responseSkills?.data?.status === "SUCCESS") {
        const skillsData = responseSkills?.data?.data;
        const profSkillsObject = skillsData?.professional_skills || {};
        const profToolsObject = skillsData?.professional_tools || {};
        const profSoftSkills = skillsData?.soft_skills || {};

        const profSkillsArray = profSkillsObject?.skills || [];
        const profToolsArray = profToolsObject?.skills || [];

        const profSoftSkillsArray = profSoftSkills?.skills || [];

        setHomeInfo((prevDetails) => ({
          ...prevDetails,
          professionalSkills: profSkillsArray,
          isProfSkillsPublic: profSkillsObject?.is_public,
          tools: profToolsArray,
          isToolsPublic: profToolsObject?.is_public,
          softSkills: profSoftSkillsArray,
          isSoftSkillsPublic: profSoftSkills?.is_public,
        }));
        // console.log("responseSkills.data:", responseSkills.data)
      }
    } catch (error) {
      console.log("GET for homeInfo failed:", error);
    }
  };

  const getAboutInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/hobbies`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      // console.log("HObbies response", response);
      if (response?.data?.statusCode === 200) {
        const data = response?.data?.data;
        const hobbiesInfo = JSON.parse(data?.hobbies_info || "[]");
        // console.log("Hbbiesssssssssssssssss", hobbiesInfo);
        setAboutMeInfo((prevDetails) => ({
          ...prevDetails,
          hobbies: hobbiesInfo,
          isHobbiesPublic: data?.is_public,
        }));
      }

      const responseLanguages = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/language/my_personal_profile`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      if (response?.data?.status === "SUCCESS") {
        const languageData = responseLanguages?.data?.data;
        // console.log("languageData:", languageData);
        const personalLangInfo = JSON.parse(languageData?.language_info || "[]");
        setAboutMeInfo((prevDetails) => ({
          ...prevDetails,
          languages: personalLangInfo,
          isLanguagesPublic: languageData?.is_public,
        }));
      }
    } catch (error) {
      console.log("GET for aboutInfo failed:", error);
    }
  };

  const getEducationInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/educational_info`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      // console.log("Education Response:", response);
      if (response?.data?.status === "SUCCESS") {
        const data = response?.data?.data;
        const transformedData = transformEducationPortfolio(data);
        const sortedEducationList = sortListByDate(
          transformedData,
          "education"
        );

        let latestDescription = "";
        let latestEducationIsPublic = false;
        let latestEduLogos = [];
        for (let i = sortedEducationList?.length - 1; i >= 0; i--) {
          if (
            !latestDescription &&
            sortedEducationList[i]?.description.trim() !== ""
          ) {
            latestDescription = sortedEducationList[i]?.description;
            latestEducationIsPublic = sortedEducationList[i]?.isPublic ?? false;
          }

          if (latestDescription) break;
        }

        // Push logos of public items only
        for (
          let i = sortedEducationList?.length - 1;
          i >= 0 && latestEduLogos?.length < 4;
          i--
        ) {
          const item = sortedEducationList[i];
          if (item?.isPublic && item?.instlogo?.data) {
            latestEduLogos.push(item?.instlogo?.data);
          }
        }

        setEducationInfo({
          educationList: sortedEducationList,
          educationStart:
            sortedEducationList?.[sortedEducationList?.length - 1]?.startYear,
          educationEnd: sortedEducationList?.[0]?.isCurrentlyPursuing
            ? "Present"
            : sortedEducationList?.[0]?.endYear,
          educationDesc:
            latestDescription ||
            "Your description of your latest education item will appear here",
          educationispublic: latestEducationIsPublic,
        });

        setHomeInfo((prevDetails) => ({
          ...prevDetails,
          recentEduLogos: latestEduLogos,
        }));
      }
    } catch (error) {
      console.log("GET for educationInfo failed:", error);
    }
  };



  const getExperienceInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/professional_experience`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      if (response?.data?.status === "SUCCESS") {
        const data = response?.data?.data;
        const transformedData = transformExperiencePortfolio(data);
        const sortedExperienceList = sortListByDate(
          transformedData,
          "experience"
        );

        let latestExpLogo = "";
        for (let i = transformedData?.length - 1; i >= 0; i--) {
          if (!latestExpLogo && transformedData[i]?.companylogo?.data !== "") {
            latestExpLogo = transformedData[i]?.companylogo?.data;
          }

          if (latestExpLogo) break;
        }

        setExperienceInfo({
          experienceList: sortedExperienceList,
          experienceStart:
            sortedExperienceList?.[sortedExperienceList?.length - 1]?.startYear,
          experienceEnd: sortedExperienceList?.[0]?.isCurrentlyWorking
            ? "Present"
            : sortedExperienceList?.[0]?.endYear,
        });

        setHomeInfo((prevDetails) => ({
          ...prevDetails,
          recentExpLogo: latestExpLogo,
        }));
      }
    } catch (error) {
      console.log("GET for experienceInfo failed:", error);
    }
  };

  const getProjectInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_project`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      if (response?.data?.status === "SUCCESS") {
        const data = response?.data?.data;
        const transformedData = transformProjectData(data);
        const sortedProjectList = sortListByDate(transformedData, "projects");

        setProjectInfo({
          projectList: sortedProjectList,
          projectStart: sortedProjectList?.[0]?.startYear,
          projectEnd: sortedProjectList?.[transformedData?.length - 1]?.endYear,
        });
      }
    } catch (error) {
      console.log("GET for projectInfo failed:", error);
    }
  };

  const getServices = async () => {
    try {
      const responseObj = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/professional_service`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );

      // Validate response structure
      if (responseObj?.status !== 200) {
        console.error(`Unexpected response status: ${response?.status}`);
        return;
      }

      const response = responseObj?.data;

      // Ensure responseData structure
      if (!response || response?.status !== "SUCCESS" || !response?.data) {
        console.error("Error: Invalid response structure or data status.");
        return;
      }

      if (response.status === "SUCCESS") {
        const data = response?.data;
        const serviceData = data[0] || {};
        // console.log("SERVICE DATA:", serviceData);
        if (Object.keys(serviceData)?.length > 0) {
          const serviceDocs = serviceData?.attachments?.map((document) => ({
            id: document?.id,
            name: document?.document_name,
            data: document?.document_url,
            type: document?.document_type,
            size:
              JSON.parse(document?.document_meta)?.document_size || "Unknown",
            date: new Date(document?.created_at).toLocaleDateString(), // Convert created_at to a readable date format
          }));
          setServices({
            id: serviceData?.id,
            yourservices: JSON.parse(serviceData?.services_info || "[]"),
            servicesDetails: serviceData?.about_services,
            workLocation: serviceData?.location,
            remote: serviceData?.is_available_remote === 1 ? true : false,
            dayStart: serviceData?.start_day,
            dayEnd: serviceData?.end_day,
            workStart: serviceData?.starting_hour,
            workEnd: serviceData?.ending_hour,
            currency: serviceData?.currency,
            hourRate: serviceData?.hourly_rate,
            serviceAttachments: serviceDocs,
            isPublic: serviceData?.is_public,
          });
        } else {
          console.log("No Services Object found!");
        }
      } else {
        console.log("Failed to fetch Services:", response.message);
      }
    } catch (error) {
      console.log("GET Services Failed", error);
    } finally {
      // //console.log('PersonalDetails', PersonalDetails);
    }
  };

  const getContactInfo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/userprofile/personal_profile`,
        {
          params: {
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );
      if (response?.data?.status === "SUCCESS") {
        const data = response?.data?.data;
        setContactInfo((prevDetails) => ({
          ...prevDetails,
          address: data?.address,
          isAddressPublic: data?.is_address_public,
        }));
      }
    } catch (error) {
      console.log("GET for projectInfo failed:", error);
    }
  };

  const getSocials = async () => {
    try {
      const professionalResponse = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`,
        {
          params: {
            cardType: "Professional",
            viewedUserId: encryptedId,
          },
          headers: headers,
        }
      );

      // console.log('professionalResponse', professionalResponse);

      // Transform the response data
      const professionalTransformedLinks = professionalResponse?.data?.map(
        (link) => ({
          network: link?.info_key,
          url: link?.info_value,
          visible: link?.is_visible,
        })
      );

      // Remove duplicates based on the network property
      const professionalUniqueLinks = professionalTransformedLinks.filter(
        (link, index, self) =>
          index === self.findIndex((t) => t.network === link.network)
      );

      // Set the state with unique links
      setProfessionalSocials({
        links: professionalUniqueLinks,
      });
    } catch (error) {
      console.error("Error fetching Social Links in Portfolio:", error);
    }
  };

  useEffect(() => {
    const getProfileInfo = async () => {
      await Promise.all([
        getUserInfo(),
        getProfessionalCardInfo(),
        getHomeInfo(),
        getAboutInfo(),
        getEducationInfo(),
        getExperienceInfo(),
        getProjectInfo(),
        getServices(),
        getContactInfo(),
        getSocials(),
      ]);
      // console.log('Portfolio - homeInfo:', homeInfo);
      // console.log('Portfolio - aboutMeInfo:', aboutMeInfo);
      // console.log('Portfolio - educationInfo:', educationInfo);
      // console.log('Portfolio - experienceInfo:', experienceInfo);
      // console.log('Portfolio - homeInfo:', homeInfo);
      // console.log('Portfolio - homeInfo:', homeInfo);
    };

    getProfileInfo();
  }, []);

  const [userDetails, setUserDetails] = useState({
    name: "",
    proFile: "",
    phone: "",
    email: "",
  });

  const [professionalCardDetails, setProfessionalCardDetails] = useState({
    cardName: "Professional",
    designation: "",
    firstName: "",
    lastName: "",
    company: "",
    profile_pic: "",
    logo: "",
    token: "",
    encryptedId: encryptedId,
  });

  const [homeInfo, setHomeInfo] = useState({
    profilePicture: userDetails?.proFile,
    aboutMe: "",
    professionalSkills: [],
    tools: [],
    softSkills: [],
    recentEduLogos: [],
    recentExpLogo: "",
    isAboutMePublic: true,
    isProfSkillsPublic: true,
    isToolsPublic: true,
    isSoftSkillsPublic: true
  });

  const [aboutMeInfo, setAboutMeInfo] = useState({
    hobbies: [],
    isHobbiesPublic: true,
    languages: [],
    isLanguagesPublic: true,
  });

  const [educationInfo, setEducationInfo] = useState({
    educationList: [],
    educationStart: "",
    educationEnd: "",
    educationDesc: "",
    educationispublic: false,
  });

  // console.log("educationInfo-----------------", educationInfo);
  const [experienceInfo, setExperienceInfo] = useState({
    experienceList: [],
    experienceStart: "",
    experienceEnd: "",
  });

  const [projectInfo, setProjectInfo] = useState({
    projectList: [],
    projectStart: "",
    projectEnd: "",
  });
  console.log("projectInfo123222", projectInfo)
  const [services, setServices] = useState({});

  const [contactInfo, setContactInfo] = useState({
    phoneNo: "",
    emailId: "",
    address: "",
    isAddressPublic: true,
  });

  const [professionalSocials, setProfessionalSocials] = useState({
    cardName: "Professional",
    links: [],
  });
  const anySocialIconsVisible = professionalSocials?.links?.some(
    (link) => link && link.visible
  );

  // Rendering Helper 
  const renderEducationItem = (education) => {
    if (education?.eduLevel === "SSLC") {
      return (
        <>
          <div className="university-Name-portfolio">
            10<sup>th</sup> / Senior Secondary
          </div>
          <div>
            {education?.institute} | {education?.universityName} |{" "}
            {education?.endYear}
          </div>
        </>
      );
    } else if (education?.eduLevel === "HSC") {
      return (
        <>
          <div className="university-Name-portfolio">
            12<sup>th</sup> / Higher Secondary
          </div>
          <div>
            {education?.institute} | {education?.degree} | {education?.endYear}
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="university-Name-portfolio">{education?.degree}</div>
          <div>
            {education?.institute} | {education?.fieldofStudy} |{" "}
            {education?.endYear}
          </div>
        </>
      );
    }
  };

  // Helper function to render Work Location
  const renderWorkLocation = (services) => {
    if (services?.workLocation && services.remote) {
      return services?.workLocation + " • " + "Also Available for Remote Work";
    } else if (services?.workLocation && !services.remote) {
      return services?.workLocation;
    } else if (!services?.workLocation && services.remote) {
      return "Available for Remote Work";
    }
  };

  const currentYear = new Date().getFullYear();

  // Define animations for text and image sliding
  const coverTextAnimation = {
    hidden: { x: -100, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.8 } },
  };

  const coverImageAnimation = {
    hidden: { x: 100, opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.8, delay: 0.5 } },
  };

  const sectionFadeInAnimation = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: 0.2 },
    },
  };

  // Mobile Responsiveness variables and functions
  const isMobileScreen = useMediaQuery('(max-width:526px)');
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen(!isDrawerOpen);

  const renderHeader = () => {
    if (isMobileScreen) {
      return <MobileHeader activeMenu={activeMenu} setActiveMenu={setActiveMenu} services={services} isDrawerOpen={isDrawerOpen} setDrawerOpen={setDrawerOpen} />;
    } else {
      return (
        <LaptopHeader activeMenu={activeMenu} setActiveMenu={setActiveMenu} services={services} />);
    }
  }

  return (
    <>
      <div className="Main-tag-portfolio background-svg" style={{ padding: isMobileScreen ? "unset" : "2%" }}>
        {renderHeader()}

        <div className="portfolio-content mobile-portfolio-body">
          {activeMenu === "cover" && (
            <>
              {!isMobileScreen ?
                <div className="content-about my-5 pt-2">
                  <motion.div
                    className="content-about-left-side text-center"
                    initial="hidden"
                    animate="visible"
                    variants={coverTextAnimation}
                  >
                    <div>
                      <div className="d-block hello-style">HELLO !!!</div>
                    </div>

                    <div className="d-block fullName_portfolio">
                      I'm {userDetails?.name}
                    </div>
                    <div className="designation-profile">
                      {/* <div className='headline-profile'>Senior Vocational High School: 11<sup style={{ color: "#000" }}>th</sup> Grade</div> */}
                    </div>
                    {/* {(homeInfo?.aboutMe && homeInfo.isAboutMePublic) ?
                                        <p className='pe-5 summary-portfolio'>{homeInfo?.aboutMe}
                                        </p>
                                        : <> </>
                                    } */}
                    {Object.keys(professionalCardDetails)?.length > 0 ? (
                      <div className="text-center">
                        <div className="mb-3">
                          Scan this QR Code to connect with me on NEOIN!
                        </div>
                        <Link
                          to={`${process.env.REACT_APP_CARD_URL}/digital-identity/${professionalCardDetails.cardName}/${userDetails.token}`}
                          target="_blank"
                          rel="noreferrer"
                          className="position-relative"
                        >
                          <div className="flex-center">
                            <QrCodeVisitingCard
                              cardDetails={professionalCardDetails}
                            />
                          </div>
                        </Link>

                        {/* <div className="flex-center">
                      <button className="portfolio-resume-download my-4">
                      <DownloadIcon className="me-2 white-svg" />
                      Download My Resume
                      </button>
                      </div> */}
                      </div>
                    ) : (
                      <> </>
                    )}
                  </motion.div>

                  <motion.div
                    className="content-about-right-side ps-2"
                    initial="hidden"
                    animate="visible"
                    variants={coverImageAnimation}
                  >
                    <div className="right-side-rectangle portfolio-item-box">
                      <div className="dynamic-portfolio start-logo">
                        <div className="d-flex justify-content-between gap-3">
                          {homeInfo?.recentEduLogos?.map((eduLogo, index) => {
                            return (
                              <img
                                key={index}
                                className="school-logo-about"
                                src={eduLogo}
                                alt={`edu logo ${index + 1}`}
                              />
                            );
                          })}
                        </div>
                        <img
                          className="logo-right-portfolio"
                          src={logo_right}
                          alt="experience"
                        />
                      </div>
                      <img
                        className="profile-picture"
                        src={homeInfo?.profilePicture || userDetails?.proFile}
                        alt="Default_image"
                      />
                    </div>
                  </motion.div>
                </div>
                : (
                  <div className="content-about flex-column mt-5 mb-3 pt-2">
                    <motion.div
                      className="text-center"
                      initial="hidden"
                      animate="visible"
                      variants={coverTextAnimation}
                    >
                      <div>
                        <div className="d-block hello-style mobile-fix">HELLO !!!</div>
                      </div>

                      <div className="d-block fullName_portfolio mobile-fix mb-3">
                        I'm {userDetails?.name}
                      </div>

                      <div className={`right-side-rectangle portfolio-item-box ${isMobileScreen ? "mb-3" : ""}`}>
                        <div className="dynamic-portfolio start-logo">
                          <div className="d-flex justify-content-between gap-3">
                            {homeInfo?.recentEduLogos?.map((eduLogo, index) => {
                              return (
                                <img
                                  key={index}
                                  className="school-logo-about"
                                  src={eduLogo}
                                  alt={`edu logo ${index + 1}`}
                                />
                              );
                            })}
                          </div>
                          <img
                            className="logo-right-portfolio"
                            src={logo_right}
                            alt="experience"
                          />
                        </div>
                        <div className="d-flex">
                          <img
                            className="profile-picture"
                            src={homeInfo?.profilePicture || userDetails?.proFile}
                            alt="Default_image"
                          />
                        </div>
                      </div>

                      {Object.keys(professionalCardDetails)?.length > 0 ? (
                        <div className="text-center">
                          <div className="mb-3">
                            Scan this QR Code to connect with me on NEOIN!
                          </div>
                          <Link
                            to={`${process.env.REACT_APP_CARD_URL}/digital-identity/${professionalCardDetails.cardName}/${userDetails.token}`}
                            target="_blank"
                            rel="noreferrer"
                            className="position-relative"
                          >
                            <div className="flex-center">
                              <QrCodeVisitingCard
                                cardDetails={professionalCardDetails}
                              />
                            </div>
                          </Link>

                          {/* <div className="flex-center">
                      <button className="portfolio-resume-download my-4">
                      <DownloadIcon className="me-2 white-svg" />
                      Download My Resume
                      </button>
                      </div> */}
                        </div>
                      ) : (
                        <> </>
                      )}
                    </motion.div>
                  </div>
                )}
            </>
          )}
          {activeMenu === "home" && (
            <>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
                className={`content-about pt-2 ${isMobileScreen ? "flex-column my-3" : " my-5"}`}
              >
                <div className={!isMobileScreen ? "content-about-left-side" : ""}>
                  {/* <div className='d-flex align-items-center justify-content-between'>
                                    <div className="d-block hello-style">HELLO !!!</div>
                                </div> */}

                  <div className={`d-block fullName_portfolio ${isMobileScreen ? "mb-3" : ""}`}>ABOUT ME</div>
                  {/* <div className='designation-profile'>
                                    <div className='headline-profile'>Senior Vocational High School: 11<sup style={{ color: "#000" }}>th</sup> Grade</div>
                                </div> */}
                  {homeInfo?.aboutMe && homeInfo?.isAboutMePublic ? (
                    <div className={`summary-portfolio line-break mb-4 ${!isMobileScreen ? "pe-5" : ""}`}>
                      {homeInfo?.aboutMe}
                    </div>
                  ) : (
                    <> </>
                  )}

                  {(homeInfo?.professionalSkills &&
                    homeInfo.isProfSkillsPublic) ? (
                    <>
                      <div className="subtitle-heading-portfolio mb-2">
                        EXPERTISE
                      </div>
                      <nav className="Nav_Portfolio pt-2">
                        <ul className="justify-content-start">
                          {/* <li>Economics</li>*/}
                          {homeInfo?.professionalSkills &&
                            homeInfo?.professionalSkills.map(
                              (skill, index) => {
                                return (
                                  <li
                                    className="portfolio-skill-item me-3"
                                    key={index}
                                  >
                                    {skill}
                                  </li>
                                );
                              }
                            )}
                        </ul>
                      </nav>
                    </>
                  ) : <> </>}

                  {(homeInfo?.softSkills && homeInfo?.isSoftSkillsPublic) ? (
                    <>
                      <div className="subtitle-heading-portfolio mb-2">
                        SOFT SKILLS
                      </div>
                      <nav className="Nav_Portfolio pt-2">
                        <ul className="justify-content-start">
                          {homeInfo?.softSkills &&
                            homeInfo?.softSkills.map((tool, index) => {
                              return (
                                <li
                                  className="portfolio-skill-item me-3"
                                  key={index}
                                >
                                  {tool}
                                </li>
                              );
                            })}
                        </ul>
                      </nav>
                    </>
                  ) : <> </>}


                  {(homeInfo?.tools && homeInfo?.isToolsPublic) ? (
                    <>
                      <div className="subtitle-heading-portfolio mb-2">
                        TOOLS
                      </div>
                      <nav className="Nav_Portfolio pt-2">
                        <ul className="justify-content-start">
                          {homeInfo?.tools &&
                            homeInfo?.tools.map((tool, index) => {
                              return (
                                <li
                                  className="portfolio-skill-item me-3"
                                  key={index}
                                >
                                  {tool}
                                </li>
                              );
                            })}
                        </ul>
                      </nav>
                    </>
                  ) : <> </>}

                  {(aboutMeInfo?.languages && aboutMeInfo?.isLanguagesPublic) ? (
                    <>
                      <div className="subtitle-heading-portfolio mb-2">
                        LANGUAGES
                      </div>
                      <nav className="Nav_Portfolio pt-2">
                        <ul className="justify-content-start">
                          {aboutMeInfo?.languages &&
                            aboutMeInfo?.languages?.map((tool, index) => {
                              return (
                                <li
                                  className="portfolio-skill-item me-3"
                                  key={index}
                                >
                                  {tool}
                                </li>
                              );
                            })}
                        </ul>
                      </nav>
                    </>
                  ) : <> </>}
                </div>
                <div className={`${!isMobileScreen ? "content-about-right-side ps-2 pt-3" : "d-none"}`}>
                  <div className="right-side-rectangle portfolio-item-box sticky-profile-picture">
                    <div className="dynamic-portfolio start-logo">
                      <div className="d-flex justify-content-between gap-3">
                        {homeInfo?.recentEduLogos?.map((eduLogo, index) => {
                          return (
                            <img
                              key={index}
                              className="school-logo-about"
                              src={eduLogo}
                              alt={`edu logo ${index + 1}`}
                            />
                          );
                        })}
                      </div>
                      <img
                        className="logo-right-portfolio"
                        src={logo_right}
                        alt="experience"
                      />
                    </div>
                    <img
                      className="profile-picture"
                      src={homeInfo?.profilePicture || userDetails?.proFile}
                      alt="Default_image"
                    />
                    {Object.keys(professionalCardDetails)?.length > 0 ? (
                      <Link
                        to={`${process.env.REACT_APP_CARD_URL}/digital-identity/${professionalCardDetails.cardName}/${userDetails.token}`}
                        target="_blank"
                        rel="noreferrer"
                        className="qrcode-portfolio"
                      >
                        <div className="flex-center">
                          <QrCodeVisitingCard
                            cardDetails={professionalCardDetails}
                          />
                        </div>
                      </Link>
                    ) : (
                      <> </>
                    )}
                  </div>
                </div>
              </motion.div>
            </>
          )}
          {activeMenu === "about" && (
            <>
              <div className="content-about mt-3 pt-2">
                <div className="portfolio-aboutme-left-side">
                  <div className="flex-center">
                    <img
                      className="Portfolio-photo-left"
                      src={homeInfo?.profilePicture || userDetails?.proFile}
                      alt={userDetails?.name}
                    />
                  </div>
                  <img
                    className="dot-style-portfolio"
                    src={dot_styles}
                    alt="dot_design"
                  />
                  <div className="subtitle-heading-portfolio mt-3">
                    LANGUAGES
                  </div>
                  <nav className="Nav_Portfolio pt-2">
                    <ul className="justify-content-start">
                      {/* <li>English</li>
                                        <li className='mx-3'>Japanese</li>
                                        <li className='mx-3'>Spainese</li>
                                        <li className='mx-3'>Hindi</li> */}
                      {aboutMeInfo?.languages &&
                        aboutMeInfo?.languages?.map((language, index) => {
                          return (
                            <li className="me-3" key={index}>
                              {language}
                            </li>
                          );
                        })}
                    </ul>
                  </nav>
                </div>
                <div className="portfolio-aboutme-right-side ps-5">
                  <div className="d-inline big-sub-headingPortfolio">
                    MY BIOGRAPHY
                  </div>
                  <p className="pe-5 summary-portfolio font-size-16px">
                    {homeInfo?.aboutMe}
                  </p>

                  <div className="mt-4 font-size-22px">SKILL & INTEREST</div>
                  <ul className="skill-list p-0">
                    {aboutMeInfo?.hobbies &&
                      aboutMeInfo?.hobbies?.map((hobby, index) => {
                        return <li key={index}>{hobby}</li>;
                      })}


                  </ul>
                </div>


              </div>
            </>
          )}
          {activeMenu === "education" && (
            <>
              {/* <div className='d-flex year-design'>
                            <div className="portfolio-aboutme-left-side"></div>
                            <div className="portfolio-aboutme-right-side ps-5">{educationInfo.educationStart} - {educationInfo?.educationEnd}</div>
                        </div> */}
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
                className={`content-about pt-2 ${isMobileScreen ? "flex-column" : ""}`}
              >
                <div className={!isMobileScreen ? "portfolio-aboutme-left-side" : "position-relative"}>
                  <div className="d-inline big-sub-headingPortfolio">
                    Education
                  </div>
                  {educationInfo?.educationispublic && <p className={`summary-portfolio font-size-16px ${!isMobileScreen ? "pe-5" : "my-4"}`}>
                    {educationInfo?.educationDesc}
                  </p>}
                </div>
                <div className={!isMobileScreen ? "portfolio-aboutme-right-side education-list mt-4 ps-5" : "education-list"}>
                  <ul className="p-0 mt-2">
                    {educationInfo?.educationList &&
                      educationInfo?.educationList
                        ?.filter((education) => education && education?.isPublic)
                        ?.map((education, index) => {
                          return (
                            <li key={index}>
                              <div className={`d-flex justify-content-between gap-3 ${isMobileScreen ? "align-items-start" : "align-items-center"}`}>
                                <div className="d-flex flex-column">
                                  {renderEducationItem(education)}
                                </div>
                                <img
                                  className="education-logo"
                                  src={education?.instlogo?.data ? education?.instlogo?.data : DefaultUniversity}
                                  alt="school"
                                />
                              </div>
                            </li>
                          );
                        })}
                  </ul>
                </div>
              </motion.div>
            </>
          )}
          {activeMenu === "experience" && (
            <>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
              >
                <div className="d-flex">
                  <div
                    className={`portfolio-aboutme-left-side ps-0 ${isMobileScreen ? "ml-20px" : "margin-left-50px"}`}
                    style={{ width: isMobileScreen ? "auto" : "40%" }}
                  >
                    <div className="d-inline big-sub-headingPortfolio ps-0">
                      Experience
                    </div>
                  </div>
                  {/* <div className="portfolio-aboutme-right-side year-design">{experienceInfo?.experienceStart} - {experienceInfo?.experienceEnd}</div> */}
                </div>
                <div className="experience-container mt-4">
                  <div className="experience-grid">
                    {experienceInfo?.experienceList &&
                      experienceInfo?.experienceList
                        ?.filter(
                          (experience) => experience && experience?.isPublic
                        )
                        ?.map((exp, index) => (
                          <div key={index} className={`experience-item ${isMobileScreen ? "flex-column" : ""}`}>
                            <div className="experience-left">
                              <img
                                src={exp?.companylogo?.data}
                                alt="Arrow"
                                className="experience-icon"
                              />
                              <div className="experience-text">
                                <h3>{exp?.companyName}</h3>
                                <h4>
                                  {exp?.roleTitle} • {exp?.startYear} -{" "}
                                  {exp?.endYear}
                                </h4>
                                <h4>
                                  {exp?.location} • {exp?.locationType}
                                </h4>
                              </div>
                            </div>
                            <div className="experience-right">
                              {exp?.details && <p>{exp.details}</p>}
                              {exp?.responsibility && (
                                <p>Responsibilities: {exp?.responsibility}</p>
                              )}
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </motion.div>
            </>
          )}
          {activeMenu === "projects" && (
            <>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
              >
                <div className="d-flex">
                  <div className="portfolio-aboutme-left-side">
                    <div
                      className={`big-sub-headingPortfolio ${isMobileScreen ? "ms-0" : "d-inline"}`}
                      style={{
                        width: "unset",
                        paddingLeft: "unset",
                        marginLeft: "40px",
                      }}
                    >
                      Selected Projects
                    </div>
                  </div>
                  {/* <div className="portfolio-aboutme-right-side pe-5 year-design d-flex justify-content-end">{projectInfo.projectStart} - {projectInfo.projectEnd}</div> */}
                </div>
                <div className={`project-container ${isMobileScreen ? "mt-3" : "mt-4"}`}>
                  {/* <div className="project-grid">
                                {projectInfo.projectList &&
                                    projectInfo.projectList
                                        ?.filter((project) => (project && project.isPublic))
                                        ?.map((project, index) => (
                                            <div key={index} className="project-item">
                                                <img src={projectImage1} alt={project.projectName} className="project-image" />
                                                <h3>{project.projectName} {project.startYear ? `| ${project.startYear}` : ''}</h3>
                                                <span className="text-left line-break">{project.projectDescription}</span>
                                            </div>
                                        ))}
                            </div> */}
                  <div className="project-grid">
                    {projectInfo?.projectList &&
                      projectInfo?.projectList
                        ?.filter((project) => project && project?.isPublic)
                        ?.map((project, index) => (
                          <div key={index} className="project-item-1">
                            {/* <img src={projectImage1} alt={project.projectName} className="project-image" /> */}
                            <h3>
                              {project?.projectName}{" "}
                              {project?.currentlyWorking
                                ? "| In Progress"
                                : project?.endYear
                                  ? `| ${project?.endYear}`
                                  : ""}
                            </h3>

                            {project?.projectDescription ? (
                              <div className="text-start line-break mb-3">
                                {project?.projectDescription}
                              </div>
                            ) : <> </>}

                            {project?.attachments?.length !== 0 && (
                              <div>
                                <div className="project-profile fw-bold mb-2">Additional Media and Links:</div>
                                <div className="d-flex flex-wrap gap-4 align-items-center">
                                  {project?.attachments?.map((attachment, index) => {
                                    console.log("Attachment:", attachment); // For debugging

                                    // Check if it's a PDF
                                    const isPdf = attachment?.type === 'application/pdf' ||
                                      attachment?.name?.toLowerCase().endsWith('.pdf');

                                    // Check if it's an image
                                    const isImage = attachment?.type?.startsWith("image/");

                                    // Check if it's a video
                                    const isVideo = attachment?.type?.startsWith("video/");

                                    // Check if it's a URL
                                    const isUrl = attachment?.type === "url";

                                    return (
                                      <div key={index}>
                                        {isImage ? (
                                          <PreviewImage file={attachment} displaySize={"80px"} />
                                        ) : isVideo ? (
                                          <PreviewVideo file={attachment} displaySize={"80px"} />
                                        ) : isUrl ? (
                                          <PreviewUrlThumbnail file={attachment} displaySize={"80px"} />
                                        ) : isPdf ? (
                                          // Remove the anchor wrapper from PreviewUrlThumbnail for PDFs
                                          <div  style={{ cursor: 'pointer' }}>
                                            <PreviewFileItem file={attachment} showOnlyIcon={true} />
                                          </div>
                                        ) : (
                                          // For other document types, show full details
                                          <PreviewFileItem file={attachment} fontColor="white" />
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                  </div>
                </div>
              </motion.div>
            </>
          )}
          {activeMenu === "services" && Object.keys(services).length > 0 && (
            <>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
              >
                <div className="d-flex">
                  <div className="portfolio-aboutme-left-side">
                    <div
                      className={`big-sub-headingPortfolio ${isMobileScreen ? "ms-0" : "d-inline"}`}
                      style={{
                        width: "unset",
                        paddingLeft: "unset",
                        marginLeft: "40px",
                      }}
                    >
                      My Services
                    </div>
                  </div>
                </div>
                <div
                  className={`d-flex project-container gap-3 ${isMobileScreen ? "flex-column" : ""}`}
                  style={{ fontSize: "18px" }}
                >
                  <div className={`Nav_Portfolio portfolio-service-left ${!isMobileScreen ? "pt-4 pe-3" : ""}`}>
                    <div className="position-sticky" style={{ top: "2rem" }}>
                      <ul className="justify-content-start">
                        {services?.yourservices?.map((serviceItem, index) => (
                          <li className="portfolio-skill-item me-3" key={index}>
                            {serviceItem}
                          </li>
                        ))}
                      </ul>
                      {services?.servicesDetails ? (
                        <div className="summary-portfolio font-size-16px my-4">
                          {services?.servicesDetails}
                        </div>
                      ) : (
                        <> </>
                      )}
                    </div>
                  </div>
                  <div className="portfolio-service-right">
                    <div className="portfolio-item-box p-3">
                      <div className="mb-4">
                        <div className="fw-bold mb-2">Availability </div>
                        <div>Location: {renderWorkLocation(services)}</div>
                        <div>
                          Timings: {services?.startDay}{" "}
                          {services?.endDay ? "- " + services?.endDay : ""} From{" "}
                          {formatTimeAmPm(services?.workStart)}{" "}
                          {services?.workEnd
                            ? " To " + formatTimeAmPm(services?.workEnd)
                            : "Onwards"}
                        </div>
                      </div>
                      <div className="mb-4">
                        <div className="fw-bold mb-2">Pricing </div>
                        <div>
                          Starting at {services.currency} {services.hourRate}/
                          hour
                        </div>
                      </div>
                      <div className="mb-4">
                        <div className="fw-bold mb-2">
                          Additional Media and Links{" "}
                        </div>
                        <div>
                          {/* Images Section */}
                          {services?.serviceAttachments?.some((attachment) =>
                            attachment?.type?.startsWith("image/")
                          ) && (
                              <div className="mb-2">
                                <div className="mb-1">Images:</div>
                                <div className="d-flex flex-wrap gap-4 align-items-center mb-3">
                                  {services?.serviceAttachments
                                    ?.filter((attachment) =>
                                      attachment?.type?.startsWith("image/")
                                    )
                                    ?.map((attachment, index) => (
                                      <PreviewImage
                                        file={attachment}
                                        displaySize={"100px"}
                                        key={index}
                                      />
                                    ))}
                                </div>
                              </div>
                            )}

                          {/* Videos Section */}
                          {services?.serviceAttachments?.some((attachment) =>
                            attachment?.type?.startsWith("video/")
                          ) && (
                              <div className="mb-2">
                                <div className="mb-1">Videos: </div>
                                <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
                                  {services?.serviceAttachments
                                    .filter((attachment) =>
                                      attachment?.type?.startsWith("video/")
                                    )
                                    .map((attachment, index) => (
                                      <PreviewVideo
                                        file={attachment}
                                        displaySize={"100px"}
                                        key={index}
                                      />
                                    ))}
                                </div>
                              </div>
                            )}

                          {/* Links Section */}
                          {services?.serviceAttachments?.some(
                            (attachment) => attachment?.type === "url"
                          ) && (
                              <div className="mb-2">
                                <div className="mb-1">Links :</div>
                                <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
                                  {services?.serviceAttachments
                                    ?.filter(
                                      (attachment) => attachment?.type === "url"
                                    )
                                    ?.map((attachment, index) => (
                                      <PreviewUrlThumbnail file={attachment} displaySize={'100px'} key={index} />
                                    ))}
                                </div>
                              </div>
                            )}

                          {/* Other Files Section */}
                          {services?.serviceAttachments?.some(
                            (attachment) =>
                              !attachment?.type?.startsWith("image/") &&
                              !attachment?.type?.startsWith("video/") &&
                              attachment?.type !== "url"
                          ) && (
                              <div className="mb-2">
                                <h5>Other Files</h5>
                                {services?.serviceAttachments
                                  .filter(
                                    (attachment) =>
                                      !attachment?.type?.startsWith("image/") &&
                                      !attachment?.type?.startsWith("video/") &&
                                      attachment?.type !== "url"
                                  )
                                  ?.map((attachment, index) => (
                                    <div key={index} className="mb-3">
                                      <PreviewFileItem file={attachment} fontColor="white" />
                                    </div>
                                  ))}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </>
          )}
          {activeMenu === "contact" && (
            <>
              <motion.div
                initial="hidden"
                animate="visible"
                variants={sectionFadeInAnimation}
                className="mt-3"
              >
                <div className="container">
                  <h1 className="text-center contact-style-portfolio">
                    GET IN TOUCH
                  </h1>
                  <h2 className="text-center contact-style-subtitle">
                    Let's Work Together
                  </h2>
                  <div className="contact-info">
                    <div className="contact-item">
                      <a href={`tel:${userDetails?.phone}`}>
                        <img src={phone_icon} alt="Phone Icon" />
                        <h3>Phone & Mobile</h3>
                        <p>{userDetails?.phone}</p>
                        {/* <p>+123-456-7890</p> */}
                      </a>
                    </div>
                    <div className="contact-item">
                      <a href={`mailto:${userDetails?.email}`}>
                        <img src={email_icon} alt="Email Icon" />
                        <h3>Email & Website</h3>
                        <p>{userDetails?.email}</p>
                        {/* <p>reallygreatsite.com</p> */}
                      </a>
                    </div>
                    {contactInfo?.address && contactInfo?.isAddressPublic && (
                      <div className="contact-item">
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactInfo?.address || '')}`}
                          target='_blank'
                          rel='noreferrer'
                        >

                          <img src={location_icon} alt="Location Icon" />
                          <h3>Address</h3>
                          <span>{contactInfo?.address}</span>
                        </a>
                      </div>
                    )}
                    {/* <div className="contact-item">
                                        <img src={instagram_icon} alt="Instagram Icon" />
                                        <h3>Instagram</h3>
                                        <p>@reallygreatsite.com</p>
                                    </div> */}
                  </div>

                  {anySocialIconsVisible ? (
                    <div className="socials-section d-flex flex-column align-items-center my-3">
                      <h4 className="mb-3">CONNECT WITH ME!</h4>
                      <div className="social-links-container">
                        {professionalSocials?.links?.map(
                          (link) =>
                            link?.visible && (
                              <a
                                key={link?.network}
                                href={link?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <div className="social-square-box">
                                  {(() => {
                                    const { icon: Icon } = getIconAndLabel(
                                      link?.network
                                    );
                                    return Icon ? (
                                      <Icon className="social-icon svg-icon-3p5rem" />
                                    ) : null;
                                  })()}
                                </div>
                              </a>
                            )
                        )}
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}
                </div>
              </motion.div>
              {/* <footer className='mt-2'>
                            <nav className='Nav_Portfolio'>
                                <ul className='margin-leftRight'>
                                    <li className="portfolio-item">
                                        <img src={line_bottom} alt="bottom-line" />
                                    </li>
                                    <li className={`portfolio-item`}> PORTFOLIO 2023</li>
                                </ul>
                            </nav>
                        </footer> */}
            </>
          )}
        </div>

        <footer>
          {activeMenu === "contact" ? (
            <>
              <div className="footer">
                {!isMobileScreen && <img src={full_line} alt="full-Line" style={{ width: "100%" }} />}
                <h1 className="year-design text-center">{userDetails?.name}</h1>
                <nav className="Nav_Portfolio">
                  <ul className="mb-0">
                    <li className="portfolio-item p-0">
                      {" "}
                      <img src={half_line_left} alt="half_line" style={{ width: isMobileScreen ? "90%" : "auto" }} />
                    </li>
                    <li className={`portfolio-item p-0`}>
                      <p> PORTFOLIO {currentYear}</p>
                    </li>
                    <li className={`portfolio-item p-0`}>
                      <img
                        src={half_line_right}
                        alt="half_right"
                        style={{ height: "15px", width: isMobileScreen ? "90%" : "auto" }}
                      />
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          ) : (
            <>
              <div className={`mt-2 Nav_Portfolio-footer ${isMobileScreen ? "mobile-footer" : ""}`}>
                <nav className="Nav_Portfolio">
                  <ul className="margin-leftRight mb-0">
                    <li className="portfolio-item footer-fancy-line">
                      <img src={line_bottom} alt="bottom-line" />
                    </li>
                    <li className={`portfolio-item`}> PORTFOLIO {currentYear}</li>
                  </ul>
                </nav>
              </div>
            </>
          )}
        </footer>
        {/* </div> */}
      </div>
    </>
  );
};

export default Portfolio;

const transformEducationPortfolio = (data) => {
  return data?.map((item) => ({
    id: item?.id,
    instlogo: {
      name: "educationLogo.png",
      type: "image/png",
      data: item?.logo_link || "",
    },
    certificatepic: {
      name: "educationCertificate.png",
      type: "image/png",
      data: item?.certificate_link || "",
    },
    eduLevel: item?.educational_level,
    universityName: item?.board,
    fieldofStudy: item?.field_of_study,
    institute: item?.institute_name,
    degree: item?.degree || "",
    grade: item?.percentage || "",
    startYear: item?.start_year,
    endYear: item?.is_pursuing === true ? "Currently Pursuing" : item?.end_year,
    isCurrentlyPursuing: item?.is_pursuing,
    description: item?.desc || "",
    isPublic: item?.is_public,
  }));
};

const transformExperiencePortfolio = (data) => {
  return data?.map((item) => ({
    id: item?.id,
    companylogo: {
      name: "logo.png",
      type: "image/png",
      data: item?.company_logo,
    },
    companyName: item?.company_name,
    roleTitle: item?.role_title,
    location: item?.location,
    locationType: item?.location_type,
    details: item?.details,
    startMonth: item?.start_month,
    startYear: item.start_year,
    endMonth: item?.end_month,
    endYear: item?.is_currently_working === true ? "Present" : item?.end_year,
    isCurrentlyWorking: item?.is_currently_working,
    responsibility: item?.responsibility,
    isPublic: item?.is_public,
  }));
};

const LaptopHeader = ({ activeMenu, setActiveMenu, services }) => {
  return (
    <header className="header-portfolio">
      <nav className="Nav_Portfolio">
        <ul className="margin-leftRight">
          <li
            className="portfolio-item"
            onClick={() => setActiveMenu("cover")}
          >
            <div className="logo-part-portfolio">
              <img src={Temp_logo} alt="logo_image" />
              {/* <div className='portfolio-item p-0'>Portfolio</div> */}
            </div>
          </li>
          <li
            className={`portfolio-item ${activeMenu === "home" ? "active" : ""
              }`}
            onClick={() => setActiveMenu("home")}
          >
            About Me
          </li>
          {/* <li className={`portfolio-item ${activeMenu === 'about' ? 'active' : ''}`}
                                onClick={() => setActiveMenu('about')}>
                                About Me
                            </li> */}
          <li
            className={`portfolio-item ${activeMenu === "education" ? "active" : ""
              }`}
            onClick={() => setActiveMenu("education")}
          >
            Education
          </li>
          <li
            className={`portfolio-item ${activeMenu === "experience" ? "active" : ""
              }`}
            onClick={() => setActiveMenu("experience")}
          >
            Experience
          </li>
          <li
            className={`portfolio-item ${activeMenu === "projects" ? "active" : ""
              }`}
            onClick={() => setActiveMenu("projects")}
          >
            Projects
          </li>
          {Object.keys(services)?.length > 0 && services?.isPublic ? (
            <li
              className={`portfolio-item ${activeMenu === "services" ? "active" : ""
                }`}
              onClick={() => setActiveMenu("services")}
            >
              Services
            </li>
          ) : (
            <> </>
          )}
          <li
            className={`portfolio-item ${activeMenu === "contact" ? "active" : ""
              }`}
            onClick={() => setActiveMenu("contact")}
          >
            Contact
          </li>
          <li>
            {" "}
            <img src={Nav_line} alt="Nav line" />{" "}
          </li>
        </ul>
      </nav>
    </header>
  )
}

const MobileHeader = ({ activeMenu, setActiveMenu, services, isDrawerOpen, setDrawerOpen }) => {

  const handleMenuClick = (menuItem) => {
    setActiveMenu(menuItem);
    setDrawerOpen(false);
  }

  return (
    <header className="header-portfolio position-fixed top-0">
      <nav className="Nav_Portfolio mobile-header">
        <div className="flex-center-between">

          <div className="logo-part-portfolio"
            onClick={() => handleMenuClick("cover")}>
            <img src={Temp_logo} alt="logo_image" />
            {/* <div className='portfolio-item p-0'>Portfolio</div> */}
          </div>

          <div onClick={() => setDrawerOpen(!isDrawerOpen)} className="pe-2">
            {isDrawerOpen ? <CloseRoundedIcon sx={{ height: "34px", width: "34px" }} /> : <MenuRoundedIcon sx={{ height: "34px", width: "34px" }} />}
          </div>
        </div>
        <ul className={`flex-column align-items-start ${isDrawerOpen ? 'drawer-open' : 'drawer-closed'}`}>
          <li
            className={`portfolio-item ${activeMenu === "home" ? "active" : ""
              }`}
            onClick={() => handleMenuClick("home")}
          >
            About Me
          </li>
          <li
            className={`portfolio-item ${activeMenu === "education" ? "active" : ""
              }`}
            onClick={() => handleMenuClick("education")}
          >
            Education
          </li>
          <li
            className={`portfolio-item ${activeMenu === "experience" ? "active" : ""
              }`}
            onClick={() => handleMenuClick("experience")}
          >
            Experience
          </li>
          <li
            className={`portfolio-item ${activeMenu === "projects" ? "active" : ""
              }`}
            onClick={() => handleMenuClick("projects")}
          >
            Projects
          </li>
          {Object.keys(services)?.length > 0 && services?.isPublic ? (
            <li
              className={`portfolio-item ${activeMenu === "services" ? "active" : ""
                }`}
              onClick={() => handleMenuClick("services")}
            >
              Services
            </li>
          ) : (
            <> </>
          )}
          <li
            className={`portfolio-item ${activeMenu === "contact" ? "active" : ""
              }`}
            onClick={() => handleMenuClick("contact")}
          >
            Contact
          </li>
        </ul>
      </nav>
    </header>
  )
}
